import ModalV2 from "@/js/components/ModalV2/ModalV2";
import { __ } from "@/utils/Trans";
import Button from '@/js/components/Buttons/Button';
import adminStore from "@/js/modules/admin/store/AdminStore";
import TextBox from "@/js/components/TextBox/TextBox";
import React from "react";

interface IUpdateUserModal {
	open: boolean;
	onClose: () => void;
	onSuccess: () => void;
	user: any
}

export default function UpdateUserModal({ onClose, onSuccess, open, user }: IUpdateUserModal) {

	const [firstName, setFirstName] = React.useState(user.firstName)
	const [lastName, setLastName] = React.useState(user.lastName)
	const [email, setEmail] = React.useState(user.email)

	const handleSubmit = async () => {
		if (user) {
			await adminStore.updateUser(user.id, { firstName, lastName, email })
			onSuccess()
		}
		onClose();
	};

	return (
		<>
			<ModalV2
				open={open}
				onClose={onClose}
				title={"Düzenle"}
			>
				<div className="max-h-[300px] min-h-[120px] h-full w-full text-left px-4 text-base text-gray-700">
					<div className={"w-full flex flex-col gap-3 sm:flex-row sm:gap-5"}>
						<div className={"sm:w-1/2"}>
							<TextBox name={"txt_FirstName"}>
								<TextBox.Label>{__("TalentEditGeneralInfo.Name")}</TextBox.Label>
								<TextBox.Input
									name={"firstName"}
									attr={{
										onChange: e => setFirstName(e.target.value),
										name: "firstName",
										value: firstName,
										maxLength: 200,
										placeholder: __("TalentEditGeneralInfo.NamePlaceholder")
									}}
								/>
							</TextBox>
						</div>
						<div className={"sm:w-1/2"}>
							<TextBox name={"txt_LastName"}>
								<TextBox.Label>{__("TalentEditGeneralInfo.LastName")}</TextBox.Label>
								<TextBox.Input
									name={"lastName"}
									attr={{
										onChange: e => setLastName(e.target.value),
										name: "lastName",
										value: lastName,
										maxLength: 200,
										placeholder: __("TalentEditGeneralInfo.LastNamePlaceholder")
									}}
								/>
							</TextBox>
						</div>
					</div>
					<TextBox name={"txt_Email"}>
						<TextBox.Label>{"Email"}</TextBox.Label>
						<TextBox.Input
							name={"email"}
							attr={{
								onChange: e => setEmail(e.target.value),
								name: "email",
								value: email,
								maxLength: 200,
								placeholder: "e-mail"
							}}
						/>
					</TextBox>
				</div>
				<div className="flex md:justify-end justify-center mt-4">
					<Button
						name={'updateUserButton'}
						attrs={{ onClick: handleSubmit }}
						classes={'w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white'}
					>
						{"Kaydet"}
					</Button>
				</div>
			</ModalV2>
		</>

	)
}
